import { useAuth } from "../auth/AuthContext";

export function UnauthorizedPage() {
  const { user, logout } = useAuth();

  return (
    <div className="centered-page">
      <div className="card" style={{ textAlign: "center", minWidth: 320 }}>
        <h1>No access yet</h1>
        <p style={{ color: "var(--text-muted)" }}>
          {user?.email ?? "Your account"} signed in successfully, but has no role assigned in the
          Maridive Reports Platform. Ask a platform administrator to assign you a role.
        </p>
        <button className="primary-button" onClick={() => void logout()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
